(()=>{
const init=(root)=>{
if(root.dataset.ready)return;root.dataset.ready='true';
const tabs=[...root.querySelectorAll('[data-panel]')],panels=[...root.querySelectorAll('[data-review-panel]')],expand=root.querySelector('[data-review-expand]');
const label=expand.textContent;
const select=(name)=>{
tabs.forEach(t=>{const on=t.dataset.panel===name;t.setAttribute('aria-selected',String(on));t.tabIndex=on?0:-1});
panels.forEach(p=>{p.hidden=p.dataset.reviewPanel!==name;p.setAttribute('role','tabpanel');const t=tabs.find(t=>t.dataset.panel===p.dataset.reviewPanel);if(t)p.setAttribute('aria-labelledby',t.id)});
root.dataset.selected=name;
};
tabs.forEach((t,i)=>{t.addEventListener('click',()=>select(t.dataset.panel));t.addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;e.preventDefault();let n=e.key==='Home'?0:e.key==='End'?tabs.length-1:(i+(e.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;select(tabs[n].dataset.panel);tabs[n].focus()})});
root.querySelector('[role="tablist"]').hidden=false;expand.hidden=false;
select(location.hash==='#kc-store-reviews'?'store':root.dataset.defaultPanel);
expand.addEventListener('click',()=>{const on=root.dataset.expanded!=='true';root.dataset.expanded=String(on);expand.setAttribute('aria-expanded',String(on));expand.textContent=on?expand.dataset.collapseLabel:label});
document.addEventListener('click',e=>{if(e.target.closest('a[href="#kc-store-reviews"]'))select('store');if(e.target.closest('.jdgm-preview-badge'))select('product')});
};
const scan=()=>document.querySelectorAll('[data-kc-reviews]').forEach(init);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();
document.addEventListener('shopify:section:load',scan);
})();

(() => {
  const bindings = new Map();
  const setup = root => {
    if (bindings.has(root)) return;
    const seen = new WeakSet();
    const load = img => {
      if (!img.getAttribute('src')) { img.loading = 'lazy'; img.decoding = 'async'; img.src = img.dataset.src; }
    };
    const near = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.isIntersecting) { load(entry.target); near.unobserve(entry.target); } });
    }, {rootMargin: '300px'}) : null;
    const scan = () => root.querySelectorAll('.jdgm-gallery__thumbnail[data-src]').forEach(img => {
      if (seen.has(img)) return;
      seen.add(img);
      const ready = () => { if (img.naturalWidth) { img.dataset.kcGalleryReady = 'true'; img.parentElement?.classList.remove('jdgm--loading'); } };
      img.addEventListener('load', ready);
      if (img.complete) ready();
      if (near) near.observe(img); else load(img);
    });
    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; if (root.isConnected) scan(); });
    });
    observer.observe(root, {childList: true, subtree: true, attributes: true, attributeFilter: ['data-src']});
    bindings.set(root, () => { observer.disconnect(); near?.disconnect(); });
    scan();
  };
  const scan = () => document.querySelectorAll('[data-kc-reviews]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', event => {
    bindings.forEach((cleanup, root) => { if (event.target.contains(root)) { cleanup(); bindings.delete(root); } });
  });
})();
